import { Award, Crown, Target, Rocket, Shield, Package, Crosshair, Cog, Forklift, Star, Hand, Lock, RefreshCw, BookOpen, GraduationCap } from 'lucide-react';

const ICONS = { rocket: Rocket, 'hand-metal': Hand, target: Target, crosshair: Crosshair, forklift: Forklift, cog: Cog, package: Package, shield: Shield, star: Star, crown: Crown, refresh: RefreshCw, book: BookOpen, graduation: GraduationCap };
const TIERS = { bronze: '#C98A4B', silver: '#B8C3CE', gold: '#F2B632' };
const TIER_OF = { first_steps: 'bronze', perfect_score: 'bronze', general_ready: 'bronze', high_five: 'silver', sharpshooter: 'silver', process_master: 'silver', inventory_guru: 'silver', pit_pro: 'gold', ten_timer: 'gold', all_star: 'gold', pit_renewed: 'silver', sop_reader: 'bronze', trainer: 'gold' };
const SIZES = { xs: 28, sm: 40, md: 64, lg: 88 };
const OUTER = 'M50 3 L94 17 V55 C94 85 73 103 50 113 C27 103 6 85 6 55 V17 Z';
const INNER = 'M50 13 L85 24 V55 C85 79 68 94 50 102 C32 94 15 79 15 55 V24 Z';

export const badgeTier = (id) => TIER_OF[id] || 'bronze';

export const BadgeShield = ({ badge, size = 'md', locked = false, className = '' }) => {
  const Icon = locked ? Lock : ICONS[badge.icon] || Award;
  const tier = TIERS[badgeTier(badge.id)];
  const px = SIZES[size];
  const trim = locked ? '#CBD5E1' : '#F37021';
  const fill = locked ? '#E2E8F0' : '#002B47';
  return (
    <div className={`relative shrink-0 ${locked ? '' : 'drop-shadow-md'} ${className}`} style={{ width: px, height: px * 1.16 }} title={`${badge.name}: ${badge.description}`} data-testid={`badge-shield-${badge.id}${locked ? '-locked' : ''}`}>
      <svg viewBox="0 0 100 116" className="absolute inset-0 w-full h-full">
        <path d={OUTER} fill={trim} />
        <path d={INNER} fill={fill} />
        {!locked && <path d="M50 13 L85 24 V40 H15 V24 Z" fill="#FFFFFF" opacity="0.08" />}
        <circle cx="50" cy="56" r="25" fill="none" stroke={locked ? '#CBD5E1' : tier} strokeWidth="3" />
      </svg>
      <div className="absolute left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center" style={{ top: `${(56 / 116) * 100}%` }}>
        <Icon size={px * 0.3} color={locked ? '#94A3B8' : tier} strokeWidth={2.2} />
      </div>
    </div>
  );
};
